import * as Sentry from '@sentry/browser';

export default {
  error(e) {
    Sentry.captureException(e);
    // eslint-disable-next-line
    console.error(e);
  },
};
